import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'dibs-elements/exports/Button';

import { getSrcString } from '../helpers/getSrcStrings';

import styles from './HpRespEditorialModuleItemOld.scss';

function HpRespEditorialModuleItemOld({ item, onClick }) {
    return (
        <div className={classnames(styles.itemWrapper, 'colXs12 colLg6')}>
            <div className={styles.item}>
                <div className={styles.linkWrapper}>
                    <a className={styles.link} href={item.link} onClick={onClick}>
                        <img className={styles.image} src={getSrcString({ url: item.imageUrl })} />
                    </a>
                </div>
                <div className={styles.content}>
                    <div className={styles.description}>{item.description}</div>
                    <Button
                        type="secondary"
                        href={item.link}
                        className={styles.button}
                        onClick={onClick}
                    >
                        {item.cta}
                    </Button>
                </div>
            </div>
        </div>
    );
}

HpRespEditorialModuleItemOld.propTypes = {
    item: PropTypes.shape({
        imageUrl: PropTypes.string,
        link: PropTypes.string,
        cta: PropTypes.string,
        description: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func,
};

HpRespEditorialModuleItemOld.defaultProps = {
    onClick: () => {},
};

export { HpRespEditorialModuleItemOld };
